













































import { Component } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { StaffEntity } from '@/entities/staff.entity';
import { get } from 'lodash';
import SingleUserBaseMixin from '@/components/ViewComponent/Thanks/AddThanksMessage/single-user-base.mixin';
import UserInfo from '@/components/ViewComponent/Thanks/AddThanksMessage/UserInfo/UserInfo.vue';
import Heart0 from '@/assets/image/heart-0.png';
import Heart1 from '@/assets/image/heart-1.png';
import Heart2 from '@/assets/image/heart-2.png';
import Heart3 from '@/assets/image/heart-3.png';
import Heart4 from '@/assets/image/heart-4.png';

import ThanksBtnPc from '../ThanksBtn/ThanksBtnPc.vue';

@Component<ThanksItemPc>({
  components: { UserInfo, ThanksBtnPc },
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
})
export default class ThanksItemPc extends SingleUserBaseMixin {
  currentStaff!: StaffEntity;
  MAX_LEVEL = 99;
  staffInteraction = 0;

  Heart0 = Heart0;
  Heart1 = Heart1;
  Heart2 = Heart2;
  Heart3 = Heart3;
  Heart4 = Heart4;

  showInfo = false;

  get getHeart() {
    const point = this.staffInteraction % 4;
    if (this.staffInteraction === 0) {
      return Heart0;
    }
    switch (point as number) {
      case 1:
        return Heart1;
      case 2:
        return Heart2;
      case 3:
        return Heart3;
      default:
        return Heart4;
    }
  }

  get getLevelHeart() {
    if (this.staffInteraction === 0) {
      return 1;
    }
    let level = Math.floor(this.staffInteraction / 4);
    const residuals = this.staffInteraction % 4;
    if (residuals !== 0) {
      level += 1;
    }
    if (level > this.MAX_LEVEL) {
      level = this.MAX_LEVEL;
    }
    return level;
  }

  get isShowBtn() {
    return this.currentStaff.id === this.getUser.id;
  }

  get isShowHeart() {
    return this.currentStaff.id !== this.getUser.id;
  }

  async mounted(): Promise<void> {
    const resData = await this.$http.get(
      `/staff-interaction/count?staffId=${this.currentStaff.id}&staffToId=${this.getUser.id}`,
    );
    this.staffInteraction = get(resData.data, 'count', 0);
  }
}
